import {
  GET_CIC_ALERTS_REQUEST,
  GET_CIC_ALERTS_SUCCESS,
  GET_CIC_ALERTS_FAILURE,
  GET_CIC_ALERT_REQUEST,
  GET_CIC_ALERT_SUCCESS,
  GET_CIC_ALERT_FAILURE,
  OPEN_CIC_ALERT_MODAL,
  CLOSE_CIC_ALERT_MODAL,
  SAVE_CIC_ALERT_REVIEW_STATE_REQUEST,
  SAVE_CIC_ALERT_REVIEW_STATE_SUCCESS,
  SAVE_CIC_ALERT_REVIEW_STATE_FAILURE,
  SAVE_CIC_ALERT_CRITERIA,
  SAVE_CIC_ALERT_SEARCH_CRITERIA,
  SAVE_CIC_ALERT_GRID_CRITERIA,
  GET_CIC_ALERT_COUNTS_REQUEST,
  GET_CIC_ALERT_COUNTS_SUCCESS,
  GET_CIC_ALERT_COUNTS_FAILURE,
  OPEN_ASSIGN_CIC_TO_USER_MODAL,
  CLOSE_ASSIGN_CIC_TO_USER_MODAL,
  CLOSE_ASSIGN_CIC_TO_USER_ERROR,
  GET_CIC_ALERT_DETAILS_REQUEST,
  GET_CIC_ALERT_DETAILS_SUCCESS,
  GET_CIC_ALERT_DETAILS_FAILURE,
  GET_CIC_ALERT_DETAILS_CLEAR,
  GET_CIC_ALERT_REPORT_REQUEST,
  GET_CIC_ALERT_REPORT_SUCCESS,
  GET_CIC_ALERT_REPORT_FAILURE
} from 'actions';

// eslint-disable-next-line default-param-last
function monitoring(state = {
  isCicAlertsListLoading: false,
  cicAlertsList: [],
  cicAlertsListCount: 0,
  cicAlertsListError: null,
  isCicAlertLoading: false,
  cicAlertId: null,
  isCicAlertModalShown: false,
  cicAlert: null,
  cicAlertError: null,
  isSavingCicReviewState: false,
  cicReviewState: null,
  cicReviewStateError: null,
  workflowState: null,
  isGettingCicAlertXls: false,
  cicAlertReportError: null,
  userCicAlerts: null,
  searchCriteria: null,
  gridCriteria: null,
  refreshPage: false
}, action) {
  switch (action.type) {
    case GET_CIC_ALERTS_REQUEST:
      return {
        ...state,
        isCicAlertsListLoading: action.isCicAlertsListLoading,
        cicAlertsListError: null,
        refreshPage: false,
      };
    case GET_CIC_ALERTS_SUCCESS:
      return {
        ...state,
        isCicAlertsListLoading: action.isCicAlertsListLoading,
        cicAlertsList: action.cicAlertsList,
        cicAlertsListCount: action.cicAlertsListCount,
        refreshPage: false,
        cicAlertsListError: null
      };
    case GET_CIC_ALERTS_FAILURE:
      return {
        ...state,
        isCicAlertsListLoading: action.isCicAlertsListLoading,
        cicAlertsList: [],
        cicAlertsListCount: 0,
        cicAlertsListError: action.cicAlertsListError,
        refreshPage: false
      };
    case GET_CIC_ALERT_REQUEST:
      return {
        ...state,
        isCicAlertLoading: action.isCicAlertLoading,
        cicAlert: null,
        cicReviewState: null,
        workflowState: null,
        cicAlertError: null
      };
    case GET_CIC_ALERT_SUCCESS:
      return {
        ...state,
        isCicAlertLoading: action.isCicAlertLoading,
        cicAlert: action.cicAlert,
        cicReviewState: action.cicReviewState,
        workflowState: action.workflowState,
        cicAlertError: null
      };
    case GET_CIC_ALERT_FAILURE:
      return {
        ...state,
        isCicAlertLoading: action.isCicAlertLoading,
        cicAlert: null,
        cicReviewState: null,
        workflowState: null,
        cicAlertError: action.cicAlertError
      };
    case OPEN_CIC_ALERT_MODAL:
      return {
        ...state,
        isCicAlertModalShown: action.isCicAlertModalShown,
        cicAlertId: action.cicAlertId,
        cicAlert: null,
        cicReviewState: null,
        workflowState: null,
        cicAlertError: null
      };
    case CLOSE_CIC_ALERT_MODAL:
      return {
        ...state,
        isCicAlertModalShown: action.isCicAlertModalShown,
        refreshPage: action.refreshPage,
        cicAlertId: null,
        cicAlert: null,
        cicReviewState: null,
        workflowState: null,
        cicAlertError: null
      };
    case SAVE_CIC_ALERT_REVIEW_STATE_REQUEST:
      return {
        ...state,
        isSavingCicReviewState: action.isSavingCicReviewState
      };
    case SAVE_CIC_ALERT_REVIEW_STATE_SUCCESS:
      return {
        ...state,
        isSavingCicReviewState: action.isSavingCicReviewState,
        cicReviewState: action.cicReviewState,
        cicReviewStateError: action.cicReviewStateError
      };
    case SAVE_CIC_ALERT_REVIEW_STATE_FAILURE:
      return {
        ...state,
        isSavingCicReviewState: action.isSavingCicReviewState,
        cicReviewStateError: action.cicReviewStateError
      };
    case GET_CIC_ALERT_REPORT_REQUEST:
      return {
        ...state,
        isGettingCicAlertXls: action.isGettingCicAlertXls,
        cicAlertReportError: null
      };
    case GET_CIC_ALERT_REPORT_SUCCESS:
      return {
        ...state,
        isGettingCicAlertXls: action.isGettingCicAlertXls,
        cicAlertReportError: action.cicAlertReportError
      };
    case GET_CIC_ALERT_REPORT_FAILURE:
      return {
        ...state,
        isGettingCicAlertXls: action.isGettingCicAlertXls,
        cicAlertReportError: action.cicAlertReportError
      };
    case SAVE_CIC_ALERT_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: action.searchCriteria
      };
    case SAVE_CIC_ALERT_GRID_CRITERIA:
      return {
        ...state,
        gridCriteria: action.gridCriteria
      };
    case SAVE_CIC_ALERT_CRITERIA:
      return {
        ...state,
        searchCriteria: action.searchCriteria,
        gridCriteria: action.gridCriteria
      };
    case GET_CIC_ALERT_COUNTS_REQUEST:
      return {
        ...state,
        isCicAlertCountsLoading: action.isCicAlertCountsLoading,
        cicAlertsCountsError: null,
        refreshPage: false,
      };
    case GET_CIC_ALERT_COUNTS_SUCCESS:
      return {
        ...state,
        isCicAlertCountsLoading: action.isCicAlertCountsLoading,
        cicAlertsUnassignedCount: action.cicAlertsUnassignedCount,
        cicAlertsAssignedCount: action.cicAlertsAssignedCount,
        refreshPage: false,
        cicAlertsCountsError: null
      };
    case GET_CIC_ALERT_COUNTS_FAILURE:
      return {
        ...state,
        isCicAlertCountsLoading: action.isCicAlertCountsLoading,
        cicAlertsUnassignedCount: 0,
        cicAlertsAssignedCount: 0,
        cicAlertsCountsError: action.cicAlertsCountsError,
        refreshPage: false
      };
    case OPEN_ASSIGN_CIC_TO_USER_MODAL:
      return {
        ...state,
        isAssignCicToUserModalShown: action.isAssignCicToUserModalShown,
        cicAlertList: action.cicAlertList,
        isTaskSuccess: false
      };
    case CLOSE_ASSIGN_CIC_TO_USER_MODAL:
      return {
        ...state,
        isAssignCicToUserModalShown: action.isAssignCicToUserModalShown,
        isTaskSuccess: false
      };
    case CLOSE_ASSIGN_CIC_TO_USER_ERROR:
      return {
        ...state,
        isAssignCicToUserModalShown: action.isAssignCicToUserModalShown,
        isTaskSuccess: false
      };
    case GET_CIC_ALERT_DETAILS_REQUEST:
      // eslint-disable-next-line no-case-declarations
      const requestCicAlerts = state.cicAlertsList.filter((c, i) => c.id === action.cicAlertId && i === action.rowId);

      if (requestCicAlerts && requestCicAlerts.length === 1) {
        requestCicAlerts[0].isLoadingDetails = true;
      }

      return {
        ...state,
        getCicAlertDetailsError: null,
        cicAlertsList: state.cicAlertsList.concat([])
      };
    case GET_CIC_ALERT_DETAILS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const matchedCicAlerts = state.cicAlertsList.filter((c, i) => c.id === action.cicAlertId && i === action.rowId);

      if (matchedCicAlerts && matchedCicAlerts.length === 1) {
        matchedCicAlerts[0].additionalData = action.cicAlertDetails;
        matchedCicAlerts[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCicAlertDetailsError: null,
        cicAlertsList: state.cicAlertsList.concat([])
      };
    case GET_CIC_ALERT_DETAILS_FAILURE:
      // eslint-disable-next-line no-case-declarations
      const failureCicAlerts = state.cicAlertsList.filter((c, i) => c.id === action.cicAlertId && i === action.rowId);

      if (failureCicAlerts && failureCicAlerts.length === 1) {
        failureCicAlerts[0].additionalData = null;
        failureCicAlerts[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCicAlertDetailsError: action.getCicAlertDetailsError,
        cicAlertsList: state.cicAlertsList.concat([])
      };
    case GET_CIC_ALERT_DETAILS_CLEAR:
      // eslint-disable-next-line no-case-declarations
      const clearCicAlerts = state.cicAlertsList.filter((c, i) => c.id === action.cicAlertId && i === action.rowId);

      if (clearCicAlerts && clearCicAlerts.length === 1) {
        clearCicAlerts[0].additionalData = null;
        clearCicAlerts[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCicAlertDetailsError: null,
        cicAlertsList: state.cicAlertsList.concat([])
      };

    default:
      return state;
  }
}

export default monitoring;
